"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Forked from https://github.com/froala/react-froala-wysiwyg
 * We had to include our own custom implementation so it was not using window.$.
 * We also fixed deprecated string ref that React does not allow.
 *
 * 10-8-18
 */
var FroalaEditor = require("../froala/froala_3.0.5/js/froala_editor");

var FroalaEditorFunctionality = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FroalaEditorFunctionality, _React$Component);

  var _super = _createSuper(FroalaEditorFunctionality);

  function FroalaEditorFunctionality(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FroalaEditorFunctionality);
    _this = _super.call(this, props); // Tag on which the editor is initialized.

    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setNormalTagContent", function (firstTime) {
      var self = (0, _assertThisInitialized2.default)(_this);

      function htmlSet() {
        self.editor.html && self.editor.html.set(self.props.model || "");
        self.oldModel = self.editor.html && self.editor.html.get();

        if (self.editorInitialized && self.editor.undo) {
          //This will reset the undo stack everytime the model changes externally. Can we fix this?
          self.editor.undo.reset();
          self.editor.undo.saveStep();
        }
      }

      if (firstTime) {
        if (_this.config.initOnClick) {
          _this.registerEvent("initializationDelayed", function () {
            htmlSet();
          });

          _this.registerEvent("initialized", function () {
            _this.editorInitialized = true;
          });
        } else {
          _this.registerEvent("initialized", function () {
            _this.editorInitialized = true;
            htmlSet();
          });
        }
      } else {
        htmlSet();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initListeners", function () {
      var self = (0, _assertThisInitialized2.default)(_this); // bind contentChange and keyup event to froalaModel

      _this.editor.events.on("contentChanged", function () {
        self.updateModel();
      });

      if (_this.config.immediateReactModelUpdate) {
        _this.editor.events.on("keyup", function () {
          self.updateModel();
        });
      }
    });
    _this.tag = null;
    _this.defaultTag = "div";
    _this.listeningEvents = []; // Jquery wrapped element.

    _this.$element = null; // Editor element.

    _this.editor = null; // Editor options config

    _this.config = {
      immediateReactModelUpdate: false,
      reactIgnoreAttrs: null
    };
    _this.editorInitialized = false;
    _this.SPECIAL_TAGS = ["img", "button", "input", "a"];
    _this.INNER_HTML_ATTR = "innerHTML";
    _this.hasSpecialTag = false;
    _this.oldModel = null;
    return _this;
  } // Before first time render.


  (0, _createClass2.default)(FroalaEditorFunctionality, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.tag = this.props.tag || this.defaultTag;
    } // After first time render.

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var tagName = this.el.tagName.toLowerCase();

      if (this.SPECIAL_TAGS.indexOf(tagName) != -1) {
        this.tag = tagName;
        this.hasSpecialTag = true;
      }

      if (this.props.onManualControllerReady) {
        this.generateManualController();
      } else {
        this.createEditor();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyEditor();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // On the Save action in the HCMS ContentFlow component, we push a forceHtmlView prop change to
      // force a toggle back to the WYSIWYG view before saving. This is to avoid additional <br> elements
      // being added on save when saving from the code view.
      // https://civicplus.tpondemand.com/entity/91547-engage6-pages-saving-while-in-code
      if (this.props.config.forceHtmlView && this.editor && this.editor.codeView.isActive()) {
        this.editor.codeView.toggle();
      }
    }
  }, {
    key: "setCustomToolbarButton",
    value: function setCustomToolbarButton(toolbarButtons, buttonName, uniqueName) {
      Object.keys(toolbarButtons).forEach(function (key) {
        var obj = toolbarButtons[key];

        if (obj.buttons) {
          var toolbarIndex = obj.buttons.indexOf(buttonName);

          if (toolbarIndex !== -1) {
            toolbarButtons[key].buttons[toolbarIndex] = uniqueName;
            return;
          }
        }
      });
    }
  }, {
    key: "createEditor",
    value: function createEditor() {
      var _this2 = this;

      if (this.editorInitialized) {
        return;
      }

      this.config = this.props.config || this.config; // Default from docs

      this.config.imageEditButtons = this.config.imageEditButtons || ["imageReplace", "imageAlign", "imageCaption", "imageRemove", "|", "imageLink", "linkOpen", "linkEdit", "linkRemove", "-", "imageDisplay", "imageStyle", "imageAlt", "imageSize"];
      this.config.customToolbarButtons && this.config.customToolbarButtons.forEach(function (button) {
        var uniqueName = "".concat(button.name).concat(Math.random()); // Deprecated way to pass in buttons as an array ['button1', 'button2']

        if (Array.isArray(_this2.config.toolbarButtons)) {
          var toolbarIndex = _this2.config.toolbarButtons.indexOf(button.name);

          if (toolbarIndex !== -1) {
            _this2.config.toolbarButtons[toolbarIndex] = uniqueName;
          }
        } else {
          // New way to pass in buttons as an array { "moreRich": { "buttons": ['button1', 'button2']}}
          _this2.setCustomToolbarButton(_this2.config.toolbarButtons, button.name, uniqueName);

          _this2.setCustomToolbarButton(_this2.config.toolbarButtonsSM, button.name, uniqueName);

          _this2.setCustomToolbarButton(_this2.config.toolbarButtonsXS, button.name, uniqueName);
        }

        if (button.isEditImage) {
          _this2.resetImageEditButtons(uniqueName, button.name);
        }

        if (button.name === "insertImage" && button.replaceCallback) {
          var self = _this2;

          var optionsWithDefaults = _objectSpread({
            title: "Replace",
            callback: function callback() {
              return button.replaceCallback(self);
            }
          }, {
            focus: false,
            undo: false,
            refreshAfterCallback: false
          }); // We need to create a unique instance of imageReplace each time
          // since we have a reference to the "this" object in the callback.


          var imageReplaceUniqueName = "imageReplace".concat(_this2.props.id);
          FroalaEditor.RegisterCommand(imageReplaceUniqueName, optionsWithDefaults);
          FroalaEditor.DefineIcon(imageReplaceUniqueName, {
            NAME: "Replace",
            SVG_KEY: "replaceImage"
          }); // Replace imageReplace with imageReplaceUniqueName so we use our unique function.

          _this2.config.imageEditButtons[0] = imageReplaceUniqueName;
          _this2.config.cpImage = {
            imageEditButtons: _this2.config.imageEditButtons
          };
        }

        _this2.makeCustomFroalaButton(uniqueName, button.icon, button.title, button.callback);
      });
      this.$element = this.el; // Check if events are set.

      if (!this.config.events) this.config.events = {}; // Default initialized.

      this.registerEvent("initialized", this.config.events && this.config.events.initialized);
      this.registerEvent("initialized", this.initListeners);
      var editor = new FroalaEditor(this.$element, this.config, function () {
        _this2.editor = editor;

        _this2.setContent(true); // Call init events.


        if (_this2._initEvents) {
          for (var i = 0; i < _this2._initEvents.length; i++) {
            _this2._initEvents[i].call(editor);
          }
        }
      });
    }
  }, {
    key: "makeCustomFroalaButton",
    value: function makeCustomFroalaButton(name, icon, title, _callback) {
      var self = this;

      var optionsWithDefaults = _objectSpread({
        title: title,
        callback: function callback() {
          return _callback(self);
        }
      }, {
        focus: false,
        undo: false,
        refreshAfterCallback: false
      });

      FroalaEditor.DefineIcon(name, {
        NAME: icon,
        template: "font_awesome"
      });
      FroalaEditor.RegisterCommand(name, optionsWithDefaults);
    }
  }, {
    key: "resetImageEditButtons",
    value: function resetImageEditButtons(uniqueName, buttonName) {
      this.config.imageEditButtons = this.config.imageEditButtons || [["imageReplace", "imageAlign", "imageCaption", "imageRemove"], ["imageLink", "linkOpen", "linkEdit", "linkRemove", "-", "imageDisplay", "imageStyle", "imageAlt", "imageSize"]];
      this.config.imageEditButtons = [uniqueName].concat(this.config.imageEditButtons.filter(function (b) {
        return b !== buttonName;
      }));
      this.config.cpImage = {
        imageEditButtons: this.config.imageEditButtons
      };
    }
  }, {
    key: "setContent",
    value: function setContent(firstTime) {
      if (this.props.model || this.props.model == "") {
        this.oldModel = this.props.model;

        if (this.hasSpecialTag) {
          this.setSpecialTagContent();
        } else {
          this.setNormalTagContent(firstTime);
        }
      }
    }
  }, {
    key: "setSpecialTagContent",
    value: function setSpecialTagContent() {
      var tags = this.props.model; // add tags on element

      if (tags) {
        for (var attr in tags) {
          if (tags.hasOwnProperty(attr) && attr != this.INNER_HTML_ATTR) {
            this.$element.setAttribute(attr, tags[attr]);
          }
        }

        if (tags.hasOwnProperty(this.INNER_HTML_ATTR)) {
          this.$element[0].innerHTML = tags[this.INNER_HTML_ATTR];
        }
      }
    }
  }, {
    key: "destroyEditor",
    value: function destroyEditor() {
      if (this.$element) {
        this.editor && this.editor.destroy && this.editor.destroy();
        this.listeningEvents.length = 0;
        this.$element = null;
        this.editorInitialized = false;
      }
    }
  }, {
    key: "getEditor",
    value: function getEditor() {
      if (this.$element) {
        return this.editor;
      }

      return null;
    }
  }, {
    key: "generateManualController",
    value: function generateManualController() {
      var self = this;
      var controls = {
        initialize: function initialize() {
          return self.createEditor.call(self);
        },
        destroy: function destroy() {
          return self.destroyEditor.call(self);
        },
        getEditor: function getEditor() {
          return self.getEditor.call(self);
        }
      };
      this.props.onManualControllerReady(controls);
    }
  }, {
    key: "updateModel",
    value: function updateModel() {
      if (!this.props.onModelChange) {
        return;
      }

      var modelContent = "";

      if (this.hasSpecialTag) {
        var attributeNodes = this.$element[0].attributes;
        var attrs = {};

        for (var i = 0; i < attributeNodes.length; i++) {
          var attrName = attributeNodes[i].name;

          if (this.config.reactIgnoreAttrs && this.config.reactIgnoreAttrs.indexOf(attrName) != -1) {
            continue;
          }

          attrs[attrName] = attributeNodes[i].value;
        }

        if (this.$element[0].innerHTML) {
          attrs[this.INNER_HTML_ATTR] = this.$element[0].innerHTML;
        }

        modelContent = attrs;
      } else {
        var returnedHtml = this.editor.html.get();

        if (typeof returnedHtml === "string") {
          modelContent = returnedHtml;
        }
      }

      if (this.oldModel !== modelContent) {
        this.oldModel = modelContent;
        this.props.onModelChange(modelContent);
      }
    }
  }, {
    key: "registerEvent",
    // register event on jquery editor element
    value: function registerEvent(eventName, callback) {
      if (!eventName || !callback) {
        return;
      }

      if (eventName == "initialized") {
        if (!this._initEvents) this._initEvents = [];

        this._initEvents.push(callback);
      } else {
        if (!this.config.events) {
          this.config.events = {};
        }

        this.config.events[eventName] = callback;
      }
    }
  }, {
    key: "registerEvents",
    value: function registerEvents() {
      var events = this.config.events;

      if (!events) {
        return;
      }

      for (var event in events) {
        if (events.hasOwnProperty(event)) {
          this.registerEvent(event, events[event]);
        }
      }
    }
  }]);
  return FroalaEditorFunctionality;
}(_react.default.Component);

exports.default = FroalaEditorFunctionality;